import { useLocation, useNavigate } from "react-router-dom";
interface StageTaskMapping {
  [status: string]: string[];
}

interface Highlighter {
  _id: string;
  name: string;
  color: string;
  icon: string;
  title: string;
  createdAt: string;
  updatedAt: string;
}

interface DataItem {
  value: string;
  label: string;
}

let StageObject: StageTaskMapping = {
  // "IPR": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "Plan Check", "Background Change", "Revision", "Waiting for Payment", "Narrarative of Changes"],
  "IPR Ready To Deliver": ["Need Info", "IPR Delivered"],
  "IPR Todo": ["Need Info", "Delivery Notes"],
  "IPR Pause": ["Need Info", "IPR Ready To Deliver", "Delivery Notes"],
  "IPR In Progress": ["Need Info", "Delivery Notes"],
  "Internal Review": ["Hour a Day", "Internal Review", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Final Review", "Plan Check", "Background Change", "Revision", "Waiting for Payment", "Narrarative of Changes"],
  "Internal Review Pause": ["Hour a Day", "Internal Review", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Final Review", "Plan Check", "Background Change", "Revision", "Waiting for Payment", "Narrarative of Changes"],
  "Final Review": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Plan Check", "Background Change", "Revision", "Final Review", "Waiting for Payment", "Narrarative of Changes"],
  "Final Review Pause": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Plan Check", "Background Change", "Revision", "Final Review", "Waiting for Payment", "Narrarative of Changes"],
  "Pause": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Plan Check", "Background Change", "Revision", "Waiting for Payment", "Narrarative of Changes"],
  "In Progress": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Plan Check", "Background Change", "Revision", "Waiting for Payment", "Narrarative of Changes"],
  "Peer Review In Progress": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Plan Check", "Background Change", "Revision", "Waiting for Payment", "Narrarative of Changes"],
  "Todo Per Review": ["Hour a Day", "Internal Review", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Plan Check", "Background Change", "Revision", "Waiting for Payment", "Narrarative of Changes"],
  "Ready To Deliver": ["Delivery Notes", "Deliver", "Plan Check", "Background Change", "Revision", "Waiting for Payment", "Narrarative of Changes"],
  "Delivered": ["Need Info", "Delivery Notes", "Plan Check", "Background Change", "Revision"],
  "Req Time Estimate": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Plan Check", "Background Change", "Revision", "Waiting for Payment", "Narrarative of Changes"],

}

let TaskObject: StageTaskMapping = {
  // "IPR": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "IPR Ready To Deliver", "Narrarative of Changes"],
  // "IPR In Progress": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "IPR Ready To Deliver", "Narrarative of Changes"],
  "IPR In Progress": ["Need Info", "Delivery Notes", "REVIT"],
  "IPR Ready To Deliver": ["Need Info", "Delivery Notes", "REVIT"],
  "IPR Todo": ["Need Info", "Delivery Notes", "REVIT"],
  "IPR Pause": ["Need Info", "IPR Ready To Deliver", "Delivery Notes", "REVIT"],
  "Internal Review": ["Ready for Final Review", "Hour a Day", "Internal Review", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Task Done", "Narrarative of Changes", "REVIT"],
  "Internal Review In Progress": ["Ready for Final Review", "Hour a Day", "Internal Review", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Task Done", "Narrarative of Changes", "REVIT"],
  "Internal Review Pause": ["Ready for Final Review", "Hour a Day", "Internal Review", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Task Done", "Narrarative of Changes", "REVIT"],
  "Final Review": ["Hour a Day", "Blocked By Trade", "Delivery Notes", "Need Info", "Final Review", "New Info Added", "Ready To Deliver", "Narrarative of Changes", "REVIT"],
  "Final Review Pause": ["Hour a Day", "Blocked By Trade", "Delivery Notes", "Need Info", "Final Review", "New Info Added", "Ready To Deliver", "Narrarative of Changes", "REVIT"],
  "Pause": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Task Done", "Narrarative of Changes", "REVIT"],
  "In Progress": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Narrarative of Changes", "REVIT"],
  "Peer Review In Progress": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Narrarative of Changes", "REVIT"],
  "Todo Per Review": ["Hour a Day", "Internal Review", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Task Done", "Final Review", "Narrarative of Changes", "REVIT"],
  "Todo Per Review Pause": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Task Done", "Narrarative of Changes", "REVIT"],
  "Todo Per Review In Progress": ["Hour a Day", "Blocked By Trade", "Need Info", "New Info Added", "Delivery Notes", "Task Done", "Narrarative of Changes", "REVIT"],
  "Ready To Deliver": ["Delivery Notes", "Narrarative of Changes", "REVIT"],
  "Delivered": ["Need Info", "Delivery Notes", "REVIT"]

}

export function filterByStatus<T extends Highlighter>(
  allHighlighters: T[],
  status: string,
  objectToFilter: StageTaskMapping
): T[] {
  const allowedNames = objectToFilter[status] || [];
  return allHighlighters?.filter(obj => allowedNames?.includes(obj?.name));
}

export const ShowHideStageAction = (allHighlighters: Highlighter[], status: string) =>
  filterByStatus(allHighlighters, status, StageObject);

export const ShowHideTaskAction = (allHighlighters: Highlighter[], status: string) =>
  filterByStatus(allHighlighters, status, TaskObject);


// Give url history to current url
export const usePreviousURL = (): ((to: string) => void) => {

  const navigate = useNavigate()
  const location = useLocation();

  const handleNavigate = (to: string) => {
    navigate(to, { state: { from: location.search } });
  };

  return handleNavigate;

};

// remove duplicates from array by given keys
export const uniqueByLabel = (array: DataItem[], key: keyof DataItem): DataItem[] => {
  const UNIQUE_ = new Set<string>();
  return array.filter(item => {
    const k = item[key];
    return UNIQUE_?.has(k) ? false : UNIQUE_?.add(k);
  });
};

export const rolePermissionsHighLighters = [
  "Hour a Day",
  "Internal Review",
  "Final Review",
  "Plan Check",
  "Revision",
  "Background Change",
  "Ready for Final Review",
  "Ready To Deliver",
  "New Info Added",
  "On Hold",
  "Project Setup"
]


export function toConvertLocalDateFormat(dateString: any) {
  if (dateString) {
    const date: Date = new Date(dateString);
    const userTimeZone: any = new Intl.DateTimeFormat().resolvedOptions();
    const { locale }: any = userTimeZone;
    const dateTimeFormate = new Intl.DateTimeFormat(locale, userTimeZone).format(date);
    console.log("User Time zone", locale);
    console.log("DB Date time", dateString);
    console.log("Convert Local DateFormat", dateTimeFormate);

    return dateTimeFormate;
  } else {
    return "";

  }
}

export function formatDateString(dateString: string): string {
  if (dateString) {
    const [year, month, day] = dateString.split('T')[0].split('-');
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthAbbreviation = months[parseInt(month, 10) - 1];

    return `${monthAbbreviation} ${parseInt(day, 10)}, ${year}`;
  } else {
    return "";

  }
}

export const lightenColor = (hex: string, percent: number): string => {
  const num = parseInt(hex.replace("#", ""), 16);
  const r = (num >> 16) + percent;
  const g = ((num >> 8) & 0x00ff) + percent;
  const b = (num & 0x0000ff) + percent;

  return `#${(
    0x1000000 +
    (r < 255 ? (r < 1 ? 0 : r) : 255) * 0x10000 +
    (g < 255 ? (g < 1 ? 0 : g) : 255) * 0x100 +
    (b < 255 ? (b < 1 ? 0 : b) : 255)
  )
    .toString(16)
    .slice(1)}`;
};

export const gradients = {
  default: "linear-gradient(135deg, #B6947E, #8F6959, #FECFB3, #AC836E, #B6947E, #F8DCCB)",
  BRONZE: "linear-gradient(135deg, #B6947E, #8F6959, #FECFB3, #AC836E, #B6947E, #F8DCCB)",
  SILVER: "linear-gradient(135deg, #7A96AC, #EAEFF3, #C2D4E1, #D2D2D2, #D4DEE5, #ABBDC8, #BCCAD7)",
  GOLD: "linear-gradient(135deg, #8C421D, #FBE67B, #F7DF77, #F4EB45, #F7D14E, #D4A041)",
  PLATINUM: "linear-gradient(135deg, #FDFFFE, #7ABBAC, #B1FFEF, #8AD2C3, #CFFEF4, #6CA196, #35544E)"
};

export const getBadgeBackground = (badges: any) => {
  // Extract badge names (ignore blank placeholders)
  const realBadges = badges
    .map((badge: any) => badge.name)
    .filter((name: string) => name !== "Blank");

  // If no real badges exist, use default background
  if (realBadges.length === 0) {
    return gradients.default;
  }

  // Check for badge types in priority order
  if (realBadges.includes("PLATINUM")) return gradients.PLATINUM;
  if (realBadges.includes("GOLD")) return gradients.GOLD;
  if (realBadges.includes("SILVER")) return gradients.SILVER;
  if (realBadges.includes("BRONZE")) return gradients.BRONZE;

  return gradients.default;
};